<template>
    <div>
        <vs-card title="Foreground Putaway" class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Foreground Putaway</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Gr id" v-model="gr_id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Gr Reference" v-model="gr_reference" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Movement ID" v-model="movement_id" disabled/>
                        </div>
                    </div>

                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-full">
                            <label for="" class="vs-input--label">Movement Date *</label>
                            <flat-pickr class="w-full" v-model="movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">

            <vs-table multiple v-model="selected" :data="pick" stripe>
                <template slot="thead">
                    <vs-th>Line ID</vs-th>
                    <vs-th>Product ID</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th>Pack ID</vs-th>
                    <vs-th>Batch</vs-th>
                    <vs-th>Box ID</vs-th>
                    <vs-th>Exp. Date</vs-th>
                    <vs-th>Qty</vs-th>
                    <vs-th>UoM</vs-th>
                    <vs-th>Stock Type</vs-th>
                    <vs-th>Location Type</vs-th>
                    <vs-th>Location ID</vs-th>
                    <vs-th>Storage Unit</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="tr.line_id">
                        {{ indextr + 1 }}
                    </vs-td>
 
                    <vs-td :data="tr.line_id">
                        {{ tr.product_code }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.description_1 }}
                    </vs-td> 
 
                    <vs-td :data="tr.line_id">
                        {{ tr.pack_id }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.batch }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.box_id }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.expired_date }}
                    </vs-td>
                    
                    <vs-td :data="tr.line_id">
                        {{ tr.base_qty}}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.base_uom_name }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.stock_type_name }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.location_type_name }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.location_code }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.storage_unit }}
                    </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vs-card>
        <vs-popup
            :active.sync="pickModal"
            title="Item Detail"
            fullscreen
            v-if="modalData.length != 0"
        >
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Line ID" v-model="modalData[0].draft_line_id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Product ID" v-model="modalData[0].product_code" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Description" v-model="modalData[0].description_1" disabled/>
                        </div>
                    </div>
                    <!-- <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" v-model="modalData[0].data_grd.product_id.description_2" disabled/>
                        </div>
                    </div> -->
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Stock Type" v-model="modalData[0].stock_type_name" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2">
                            <vs-input class="w-full" label="Base Qty" :value="modalData[0].total_item" disabled/>
                        </div>
                        <div class="vx-col md:w-1/2">
                            <vs-input class="w-full" label=" " v-model="modalData[0].base_uom_name" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mt-10" style="padding-left: 10px; padding-right: 10px">
                <vs-card title="Item Details" class="p-4 mb-6">
                    <div slot="header" class="flex flex-wrap items-center justify-between">
                        <div class="flex items-center">
                            <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="deleteData">Delete</vs-button>
                        </div>
                        <div class="flex items-center">
                            <vs-button color="warning" class="btn mb-4 md:mb-0 mr-1" @click="skipData">Skip</vs-button>
                            <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="saveData">Save</vs-button>
                        </div>
                    </div>
                    <div style="overflow-x: auto">

                        <vs-table multiple v-model="modalSelected" :data="modalData" stripe>
                            <template slot="thead">
                                <vs-th>Line ID</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Box ID</vs-th>
                                <vs-th>Exp. Date</vs-th>
                                <vs-th style="width: 10%">Qty</vs-th>
                                <vs-th>UoM</vs-th>
                                <vs-th>Location ID</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td>
                                        {{ indextr + 1 }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.pack_id }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.batch }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.box_id }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.expired_date }}
                                    </vs-td>

                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.base_qty"/>
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.base_uom_name }}
                                    </vs-td>

                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.location_id"
                                            width="100%"
                                            autocomplete
                                            @input="changeLocation(tr)"
                                        >
                                            <vs-select-item v-for="(item, index) in locationOption" :key="index" :value="item.value" :text="item.text"/>
                                        </vs-select>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vs-card>
            </div>
        </vs-popup>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'

export default {
    components:{
        flatPickr,
        vSelect
    },
    data() {
        return {
            selected: [],
            pick: [],
            drafts: [],
            gr_reference: 'sda',
            gr_id:'',
            movement_id:'',
            movement_date: new Date(),
            currentIndex: 0,
            pickModal: false,
            modalData: [],
            pickAssignError: '',
            locationOption: [],
            modalSelected: [],
            isLoading: false,
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }

    },
    methods: {
        getPartition(){
           // this.pickModal = false;
           let data_send = {
              good_receive:JSON.stringify({
                gr_id:this.gr_id
              }), 
              good_receive_details:JSON.stringify({
                grd_id:this.grItems[this.currentIndex].id
              })
            };
            this.$http.post('putaway/foreground/partition', data_send)
            .then(res => {
               this.modalData = res.data; 
                this.$http.post('master/locations/filter/dropdown')
                .then(res => {
                    res.data.map(item => {
                        this.locationOption.push({
                            value: item.id,
                            text: item.location_code
                        })
                    this.pickModal = true;
                        this.isLoading = false
                    })
                })
                .catch((error) => {
                    console.log(error)
                })

            }).catch(error =>{
                const message = error.response.data ? error.response.data : 'Something went wrong'
                        this.isLoading = false
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
                console.log(error.response.data)
            })
            },
        fetchData() {
            this.$http.get('master/locations/filter/available')
            .then(locations => {
                locations.data.map(item => {
                    this.locationOption.push({
                        value: item.id,
                        text: item.location_code
                    })
                })

                const dataSend = {
                    good_receive: JSON.stringify({id:this.$route.params.id})
                }

                this.$http.post('putaway/background/draftputaway', dataSend)
                .then(res => {
                    this.gr_id = this.$route.params.id;
                    this.gr_reference = res.data.data_gr.gr_reference;

                    res.data.list_draftputaway.map(item => {
                        item.data_status = 'submit'
                    })

                    let groupBy = key => array =>
                    array.reduce((objectsByKeyValue, obj) => {
                        const value = obj[key];
                        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                        return objectsByKeyValue;
                    }, {})

                    let groupById = groupBy('grd_id')
                    let partitionData = groupById(res.data.list_draftputaway)

                    Object.values(partitionData).map(item => {
                        this.drafts.push(item)
                    })

                    this.drafts.map(item => {
                        let totalItem = 0
                        
                        item.map(value => {
                            totalItem += value.base_qty
                        })

                        item.map(value => {
                            value.total_item = totalItem
                        })
                    })
                    
                    this.isLoading = false
                    this.showModal(this.currentIndex)
                })
                .catch((error) => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.$router.push({
                        name: 'good-receive-view',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            })
            .catch((error) => {
                this.isLoading = false
                console.log(error)
            })
        },
        back() {
            this.$vs.dialog({
                color: 'warning',
                title: 'Leave Page',
                text: 'Changes you made may not be saved?',
                acceptText: 'Leave Page',
                accept: () => this.$router.push({ name: 'good-receive-view', params: {id: this.$route.params.id} }),
            })
        },
        submitForm() {
            let error = false
            const moHead = {
                gr_id: this.$route.params.id,
                movement_date: this.movement_date
            }

            var details = []

            if(this.pick.length <= 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Putaway line is empty'
                })
                return false
            }
            this.isLoading = true ;
            this.pick.map((item, index) => {
                if(!item.location_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Line ' + item.line_id + '. No location assigned'
                    })
                    error = true
                }
                else {
                    details.push({
                    line_id: index + 1,
                    grd_id: item.grd_id,
                    draft_id: item.id,
                    movement_date:this.movement_date,
                    base_qty: item.base_qty,
                    location_id: item.location_id,
                    dest_storage_unit:  item.storage_unit,
                    inventories_first_id:  item.inventory_first_id,
                  })
                }
            })

            if(error) {
                this.isLoading = false ;
                return false
            }
            else {
                const dataSend = {
                    movement_order: JSON.stringify(moHead),
                    movement_order_details: JSON.stringify(details)
                }

                this.$http.post('putaway/background/store', dataSend)
                .then(() => {
                    this.isLoading = false ;
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully'
                    })
                    this.$router.push({ name: 'good-receive-view', params: {id: this.$route.params.id} })
                })
                .catch(() => {
                    this.isLoading = false ;
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Something went wrong'
                    })
                })
            }
        },
        showModal(index) {
            this.modalSelected = []
            if(!this.drafts[index]) {
                return false
            }
            else {
                let lineId = 1
                this.modalData = []
                this.pickModal = true
                this.drafts[index].map(data => {
                    this.modalData.push(data)
                })

                this.modalData.map(item => {
                    item.draft_line_id = lineId
                    lineId++
                })
            }
        },
        skipData() {
            this.modalSelected = []
            this.pickModal = false
            this.currentIndex++
            this.showModal(this.currentIndex)
        },
        saveData() {
            let deletedCount = 0
            const lineData = []
            let error = false
            const expectedQty = this.modalData[0].total_item
            let currentQty = 0
            const ids = []

            this.modalData.map(item => {
                if(item.data_status == 'delete') {
                    deletedCount++
                }
            })

            if(deletedCount >= this.modalData.length) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Detail is empty'
                })
                return false
            }


            for(let i = 0; i < this.modalData.length; i++) {
                if(!this.modalData[i].location_id && this.modalData[i].data_status == 'submit') {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No location ID assigned. Line ' + this.modalData[i].draft_line_id
                    })
                    error = true
                }
                else {
                    lineData.push({
                        inventory_id: this.modalData[i].inventory_first_id,
                        qty: this.modalData[i].base_qty,
                        draft_id: this.modalData[i].id,
                        value: this.modalData[i].data_status,
                        line_id: this.modalData[i].draft_line_id
                    })
                }
            }


            this.modalData.map(item => {
                currentQty += parseInt(item.base_qty)
            })

            if(currentQty > expectedQty) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Item quantity exceed. Base qty: ' + expectedQty + ' - Assigned qty: ' + currentQty
                })
                error = true
            }

            if(error) {
                return false
            }

            this.modalData.map(item => {
                ids.push({
                    draft_id: item.id,
                    location_id: item.location_id,
                    base_qty: item.base_qty
                })
            })

            this.isLoading = true
            this.$http.post('putaway/background/draftputaway/update', {list_draft_putaway: JSON.stringify(ids)})
            .then(() => {
                this.isLoading = false
                this.modalData.map(item => {
                    this.pick.push(item)
                })
                this.selected = []
                this.skipData()
            })
            .catch(error => {
                this.isLoading = false
                console.log(error)
            })
        },
        deleteData() {
          if(this.modalSelected.length == this.modalData.length) {
                this.$vs.notify({   
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon: 'icon-x',
                    text: `Can't delete all data`
                })
            }
            else {
                this.modalSelected.map(item => {
                    this.modalData.map((data, index) => {
                        if(item.draft_line_id == data.draft_line_id) {
                            this.modalData.splice(index, 1)
                        }
                    })
                })

                this.modalSelected = []
                this.assignLineId()
            }
        },
        assignLineId() {
            let lineNumber = 1

            this.modalData.map(data => {
                data.draft_line_id = lineNumber
                lineNumber++
            })
        },
        changeLocation(tr) {
            this.locationOption.map(item => {
                if(tr.dest_location.id == item.value) {
                    tr.dest_location.dest_location_name = item.text
                }
            })
        }
    },
    mounted() {
        this.isLoading = true ;
        if(this.isLoading){
            this.$vs.loading()
        }
        this.gr_id = this.$route.params.id;
        this.grItems = this.$route.params.details;
        this.fetchData();
    }
}
</script>